import { useState } from "react";
import PageHeader from "@/components/app/PageHeader";
import ResourceManager from "@/components/app/ResourceManager";
import Products from "@/pages/Products";
import Lenders from "@/pages/Lenders";
import Agents from "@/pages/Agents";
import Partners from "@/pages/Partners";
import { Package, Bank, UsersThree, Handshake, UsersFour } from "@phosphor-icons/react";
import { Badge } from "@/components/ui/badge";

const inhouseConfig = {
  endpoint: "inhouse-team",
  testid: "inhouse",
  singular: "Team Member",
  overline: "All List",
  title: "Inhouse Team",
  subtitle: "Paisapaid internal team members used in Disbursement lead sourcing.",
  accent: "loan",
  perms: { add: "employees.add", edit: "employees.edit", delete: "employees.delete" },
  columns: [
    { key: "name", label: "Name", render: (r) => <span className="font-medium text-zinc-900">{r.name}</span> },
    { key: "team_id", label: "Team ID", badge: true },
    { key: "role_title", label: "Role" },
    { key: "mobile", label: "Mobile" },
    { key: "email", label: "Email" },
    { key: "active", label: "Status", render: (r) => (
      <Badge variant="outline" className={`rounded-sm font-normal ${r.active ? "border-emerald-500 text-emerald-600" : "border-zinc-300 text-zinc-400"}`}>{r.active ? "Active" : "Inactive"}</Badge>
    ) },
  ],
  fields: [
    { name: "name", label: "Full Name", type: "text", required: true, colSpan: 2 },
    { name: "role_title", label: "Role / Title", type: "text" },
    { name: "mobile", label: "Mobile", type: "text" },
    { name: "email", label: "Email", type: "email" },
    { name: "active", label: "Active", type: "switch" },
  ],
};

const TABS = [
  { key: "products", label: "Products", icon: Package, comp: <Products /> },
  { key: "lenders", label: "Lenders", icon: Bank, comp: <Lenders /> },
  { key: "agents", label: "Paisapaid Agents", icon: UsersThree, comp: <Agents /> },
  { key: "partners", label: "Own Brand Partners", icon: Handshake, comp: <Partners /> },
  { key: "inhouse", label: "Inhouse Team", icon: UsersFour, comp: <ResourceManager config={inhouseConfig} /> },
];

export default function AllList() {
  const [tab, setTab] = useState("products");
  return (
    <div data-testid="all-list-page">
      <PageHeader overline="Masters" title="All List" subtitle="Manage products, lenders, agents, partners and your inhouse team." />
      <div className="flex flex-wrap gap-1 mb-6 bg-white border border-zinc-200 rounded-sm p-1 w-fit">
        {TABS.map((t) => (
          <button key={t.key} data-testid={`alllist-tab-${t.key}`} onClick={() => setTab(t.key)}
            className={`flex items-center gap-2 px-4 py-2 text-sm rounded-sm transition-colors ${tab === t.key ? "bg-zinc-900 text-white" : "text-zinc-500 hover:bg-zinc-100"}`}>
            <t.icon size={16} weight="duotone" /> {t.label}
          </button>
        ))}
      </div>
      <div>{TABS.find((t) => t.key === tab)?.comp}</div>
    </div>
  );
}
